import { Component, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
declare function attractionSlick(): void;
@Component({
  selector: 'train-attraction',
  standalone: true,
  imports: [],
  templateUrl: './train-attraction.component.html',
})
export class TrainAttractionComponent {

  @Input() attractionArray: any;
  flag:boolean = false;
  url:string = environment.url;

  ngAfterViewInit() {
    this.flag = true;
  }

  ngOnChanges() {
    if(this.flag && this.attractionArray?.length > 0){
      setTimeout(() => {
        attractionSlick();
      }, 0);
      this.flag = false;
    }
  }


  getChLength(length: number){
    if(length > 1000){
        return (length/1000).toFixed(2) + "公里" ;
    }else{
      return length.toFixed(0) + "公尺";
    }
  }


}
